import React from "react";
import DemographicsCard from "./DemographicsCard";
import SalaryRoleAnalysisCard from "./SalaryRoleAnalysisCard";
import PerformanceOutliersCard from "./PerformanceOutliersCard";
import IconSvg from "./IconSvg";
import "./style.css";
import { IconButton, Tooltip } from "@mui/material";
import { InfoIcon } from "lucide-react";

const BatchProfileSection = ({
  data,
  onViewAllRoles,
  onViewAllStudents,
  onSalaryAnalysis,
}) => {
  return (
    <section className="mb-6">
      <h2 className="section-heading">
        <IconSvg
          path="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
          className="h-5 w-5 mr-2 text-primary-600"
        />
        Batch Profile & Performance
        <div className="tooltip-wrapper">
          <IconSvg
            path="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            className="h-4 w-4 text-gray-400"
          />
          <div className="tooltip-content w-64">
            Overview of key batch demographics, skills, and performance metrics
            across different parameters.
          </div>
        </div>
      </h2>
      <div className="grid grid-cols-1 lg-grid-cols-12 gap-4">
        <DemographicsCard
          data={data.demographics}
          onViewAllRoles={onViewAllRoles}
        />
        <SalaryRoleAnalysisCard
          data={data.salaryRoleAnalysis}
          onViewAllRoles={onSalaryAnalysis}
        />
        <PerformanceOutliersCard
          data={data.performanceOutliers}
          onViewAllStudents={onViewAllStudents}
        />
      </div>
    </section>
  );
};

export default BatchProfileSection;
